import { i18nFactory } from '@lib/i18n';

const ru = {
    search: 'Поиск',
    resetForm: 'Сбросить',
    share: 'Поделиться',
    empty: 'Ничего не найдено🤷‍♂️',
};

const en = {
    search: 'Search',
    resetForm: 'Reset',
    share: 'Share',
    empty: 'Nothing was found🤷‍♂️',
};

const ka = {
    search: 'ძიება',
    resetForm: 'გადაყარეთ',
    share: 'გაზიარება',
    empty: 'ვერაფერი იპოვეს🤷‍♂️',
};

export const i18n = i18nFactory({ ru, en, ka });
